import CoreAppService from '../_shared/api/coreAppService';
import Singleton from '../Singleton';
import { sessionStorageService } from './StorageService';

interface ITradeInProps {
  phoneNumber?: string;
  code?: string;
  dealerId?: number;
  dealerDisplayName?: string;
  location?: {
    latitude: number;
    longitude: number;
  };
}

export default class TradeInService extends Singleton<TradeInService> {
  /**
   * Sends a verification code to the given phoneNumber using twilio verify
   */
  static verifyPhoneNumber = async (phoneNumber: string) => {
    let response;
    try {
      const client = await CoreAppService();
      response = await client.tradein.verify({
        phoneNumber
      });
    } catch (e) {
      return e;
    }

    return response?.data;
  };

  /**
   * Checks for the validity of twilio verify code and returns a TradeInvitationToken
   */
  static verifyCode = async (params: {
    phoneNumber: string;
    code: string;
    dealerId: number;
    dealerDisplayName: string;
  }) => {
    let response;

    try {
      const client = await CoreAppService();
      response = await client.tradein.check({
        phoneNumber: params.phoneNumber,
        code: params.code,
        dealerId: params.dealerId,
        dealerDisplayName: params.dealerDisplayName
      });
    } catch (e) {
      return e;
    }

    return response?.data;
  };

  /**
   * Returns dealer location in the area described the user location
   */
  static getDealerLocations = async (params: {
    isFranchiseDealerOnly: boolean;
    radius: number;
    point: {
      latitude: number;
      longitude: number;
    };
  }) => {
    let response;

    try {
      const client = await CoreAppService();

      response = await client.tradein.dealerLocator({
        isFranchiseDealerOnly: params.isFranchiseDealerOnly,
        point: params.point,
        radius: params.radius
      });
    } catch (e) {
      return e;
    }

    return response?.data;
  };

  /**
   * Sets the tradeIn user supplied properties
   */
  static updateUserTradeInProps(updatedTradeInProps: ITradeInProps) {
    const setUserTradeInProps = sessionStorageService.getItem('userTradeIn');
    sessionStorageService.setItem('userTradeIn', {
      ...setUserTradeInProps,
      ...updatedTradeInProps
    });
  }

  /**
   * Retrieves the tradeIn user supplied properties
   */
  static getUserTradeInProps(): ITradeInProps {
    return sessionStorageService.getItem('userTradeIn');
  }

  /**
   * Removes the tradeIn user supplied properties
   */
  static removeUserTradeInProps() {
    return sessionStorageService.removeItem('userTradeIn');
  }
}
